class Keyvisual {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        const videoItems = this.elem.querySelectorAll('.video');
        if (videoItems) {
            videoItems.forEach((video) => {
                video.addEventListener('click', () => {
                    video.closest('.keyvisual__item').classList.add('keyvisual__item--video-playing');
                });
            });
        }
    }
}

export default Keyvisual;
